export function createExtraGradeLine() {
  return {
    id: `extra-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    label: '',
    grade: '',
  };
}

export function sanitizeExtraGradeLines(lines) {
  return (Array.isArray(lines) ? lines : [])
    .map((line) => ({
      id: String(line?.id || ''),
      label: String(line?.label || '').trim(),
      grade: String(line?.grade || '').trim(),
    }))
    .filter((line) => line.label || line.grade);
}

export function extraGradeDisplayFields(report) {
  return sanitizeExtraGradeLines(report?.extraLines).map((line, index) => ({
    label: line.label || `Extra grade ${index + 1}`,
    value: line.grade,
    field: line.id || `extra-${index}`,
  }));
}
